module.exports = __webpack_public_path__ + "img/altraQUALITA.85916f38.png";